/*
 * Copyright (c) AXA Group Operations Spain S.A.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

const { Stopwords } = require('@nlpjs/core');

class StopwordsPt extends Stopwords {
  constructor(container, words) {
    super(container);
    this.name = 'stopwords-pt';
    this.dictionary = {};
    const list = words || [
      'a',
      'à',
      'ao',
      'aos',
      'aquela',
      'aquelas',
      'aquele',
      'aqueles',
      'aquilo',
      'as',
      'às',
      'até',
      'com',
      'como',
      'da',
      'das',
      'de',
      'dela',
      'delas',
      'dele',
      'deles',
      'depois',
      'do',
      'dos',
      'e',
      'ela',
      'elas',
      'ele',
      'eles',
      'em',
      'entre',
      'essa',
      'essas',
      'esse',
      'esses',
      'esta',
      'estas',
      'este',
      'estes',
      'eu',
      'isso',
      'isto',
      'já',
      'lhe',
      'lhes',
      'mais',
      'mas',
      'me',
      'mesmo',
      'meu',
      'meus',
      'minha',
      'minhas',
      'muito',
      'muitos',
      'na',
      'não',
      'nas',
      'nem',
      'no',
      'nos',
      'nós',
      'nossa',
      'nossas',
      'nosso',
      'nossos',
      'num',
      'nuns',
      'numa',
      'numas',
      'o',
      'os',
      'ou',
      'para',
      'pela',
      'pelas',
      'pelo',
      'pelos',
      'por',
      'quais',
      'qual',
      'quando',
      'que',
      'quem',
      'se',
      'sem',
      'seu',
      'seus',
      'só',
      'sua',
      'suas',
      'também',
      'te',
      'teu',
      'teus',
      'tu',
      'tua',
      'tuas',
      'um',
      'uma',
      'umas',
      'você',
      'vocês',
      'vos',
      'vosso',
      'vossos',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '0',
      '_',
    ];
    this.build(list);
  }
}

module.exports = StopwordsPt;
